import { useLocalStorageContext } from '../../../contexts/LocalStorageContext'

interface LinkItem {
  href: string
  name: string
  additionalInfo?: string
  topic?: string
}

export interface Links {
  title: string
  items: LinkItem[]
}

const links = (): Links[] => {
  const emails: { [key: string]: string } = {
    smrholding: 'atendimento@smboa.com.br',
    boa: 'atendimento@smboa.com.br',
    superpao: 'faleconosco@superpao.com.br',
    compremais: 'faleconosco@clientecompremais.com.br',
    domolivio: 'atendimento@domolivio.com.br',
    avenidab2c: 'faleconosco@casaavenida.com.br',
  }

  const { getLocalStorage } = useLocalStorageContext()
  const storeId = getLocalStorage('storeId')

  const finalEmail = emails[storeId ?? '']

  return [
    {
      title: 'Central de Atendimento',
      items: [
        {
          href: '/atendimento',
          name: 'Atendimento e Solução de Problemas',
        },
        {
          href: '/atendimento?topic=Pedido,+Cancelamentos,+Trocas+e+Devoluções',
          name: 'Pedido, Cancelamentos, Trocas e Devoluções',
          topic: 'Pedido, Cancelamentos, Trocas e Devoluções',
        },
        {
          href: '/atendimento?topic=Entrega',
          name: 'Problemas com Entrega',
          topic: 'Entrega',
        },
        {
          href: '/atendimento?topic=Pagamento',
          name: 'Problemas com Pagamento',
          topic: 'Pagamento',
        },
        {
          href: '/atendimento?topic=Cadastro+e+Dados+Pessoais',
          name: 'Problemas com Cadastro e Dados Pessoais',
          topic: 'Cadastro e Dados Pessoais',
        },
      ],
    },
    {
      title: 'Contato',
      items: [
        {
          href: `mailto: ${finalEmail ?? ''}`,
          name: finalEmail,
        },
        {
          href: '/institucional/trabalheConosco',
          name: 'Trabalhe Conosco',
        },
      ],
    },
    {
      title: 'Institucional',
      items: [
        {
          href: '/institucional/sobre',
          name: 'Nossa História',
        },
        {
          href: '/institucional/lojas',
          name: 'Nossas Lojas e Serviços',
        },
        {
          href: 'https://www.canaldeetica.com.br/plurix/',
          name: 'Canal de ética',
        },
      ],
    },
    {
      title: 'Nossos Termos e Políticas',
      items: [
        {
          href: '/institucional/termos',
          name: 'Termos e Condições de Uso',
        },
        {
          href: '/institucional/privacidade',
          name: 'Política de Privacidade',
        },
        {
          href: '/institucional/politica-cookie',
          name: 'Política de Cookie',
        },
        {
          href: 'https://canaldeetica.com.br/plurixlgpd/',
          name: 'Canal de Solicitações de Direitos – LGPD',
        },
      ],
    },
  ]
}

export { links, LinkItem }
